var endpointMap = {
	en: {
		strings: "translation-en.json"
	},
	"en-US": {
		strings: "translation-en.json"
	},
	und: {
		strings: "translation.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
